import { render } from "./XContact.vue?vue&type=template&id=97f0f06c&scoped=true"
import script from "./XContact.vue?vue&type=script&lang=js"
export * from "./XContact.vue?vue&type=script&lang=js"

import "./XContact.vue?vue&type=style&index=0&id=97f0f06c&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f0f06c"]])

export default __exports__